import { useEffect, useState } from "react";

//Props Validations
import PropTypes from "prop-types";

//Material UI Components
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Checkbox from "@mui/material/Checkbox";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormGroup from "@mui/material/FormGroup";
// import Icon from "@mui/material/Icon";

// import mui icons
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";

//import assets
import forwardPng from "../../assets/forward.png";

// import component

// import helper
import ConsumerFilterOrder from "utils/ConsumerFilterOrder";

// common components
import MatchNetMissingFiltersTooltip from "./MatchNetMissingFiltersTooltip";
import AppliedFiltersTooltip from "./AppliedFiltersTooltip";
import MissingFiltersDialog from "../common/MissingFiltersDialog";

//utils
import { checkFilterSelection, filterAcrossProducts } from "utils/consumerFilterUtils";
import GetConsumerFilterOrder, { getMacroCategoryOrder } from "utils/GetConsumerFilterOrder";

//redux
import { useSelector, useDispatch } from "react-redux";
import { loadWeightToggleState, loadDisableWeightToggleState } from "store/features/analysisResultsSlice";
import { updateConsumerFilterValue } from "store/features/matchNetSlice";

function ConsumerFilter({ product = {}, productsSecondaryData = [], handleFilterSubmit = () => {}, type = null, studyTypeMethod = "", disableFilter = false }) {
    const dispatch = useDispatch();
    const filterData = useSelector((state) => state.matchNetStore.consumerFilters[studyTypeMethod]);

    const correlationConsumerFilters = ConsumerFilterOrder.correlationConsumerFilters;
    const consumerFilterStoreData = useSelector((state) => state.consumerFilterStore.filters);
    const missingFiltersStoreData = filterData.missingFilters;
    const isFilterAcrossProductsStoreData = filterData.isFilterAcrossProducts;
    const dataMappingStoreData = useSelector((state) => state.dataMappingStore.displayLabelTranslation);
    const allAnalysisData = useSelector((state) => state.analysisResultsStore);
    const productCategoryData = useSelector((state) => state.settingsStore.productCategory);

    const overallBoxAnalysisSelection = useSelector((state) => state.analysisTypeSelectionStore.overallBoxAnalysisSelection);
    const secondaryBoxAnalysisSelection = useSelector((state) => state.analysisTypeSelectionStore.secondaryBoxAnalysisSelection);
    const agreementBoxAnalysisSelection = useSelector((state) => state.analysisTypeSelectionStore.agreementBoxAnalysisSelection);
    const claimsBoxAnalysisSelection = useSelector((state) => state.analysisTypeSelectionStore.claimsBoxAnalysisSelection);
    const expressCltOverallBoxAnalysisSelection = useSelector((state) => state.analysisTypeSelectionStore.expressCltOverallBoxAnalysisSelection);
    const fragranceOverallBoxAnalysisSelection = useSelector((state) => state.analysisTypeSelectionStore.fragranceOverallBoxAnalysisSelection);
    const expressCltAdditionalBoxAnalysisSelection = useSelector((state) => state.analysisTypeSelectionStore.expressCltAdditionalBoxAnalysisSelection);
    const fragranceAdditionalBoxAnalysisSelection = useSelector((state) => state.analysisTypeSelectionStore.fragranceAdditionalBoxAnalysisSelection);

    const [missingFiltersDialogOpen, setMissingFiltersDialogOpen] = useState(false);

    const [consumerFilter, setConsumerFilter] = useState(consumerFilterStoreData);

    const [tempMissingFilters, setTempMissingFilters] = useState({});

    const cfStoreData = JSON.parse(JSON.stringify(filterData.currentSelectedFilters));
    const cfAllStoreData = JSON.parse(JSON.stringify(filterData.currentSelectedAllFilters));
    const selectedStudies = useSelector((state) => state.studyDataStore.selectedStudies);

    const [currentFilterStoreData, setCurrentFilterStoreData] = useState(JSON.parse(JSON.stringify(filterData.currentSelectedFilters)) || {});
    const [currentFilterAllStoreData, setCurrentFilterAllStoreData] = useState(JSON.parse(JSON.stringify(filterData.currentSelectedAllFilters)) || {});

    const [open, setOpen] = useState(false);

    const [backendVariableLabel, setBackendVariableLabel] = useState([]);
    const [selectedFilter, setsSelectedFilter] = useState("");

    const [selectedFilterBackendVariables, setsSelectedFilterBackendVariables] = useState([]);
    const [groupedVariables, setGroupedVariables] = useState([]);
    const [macroCategories, setMacroCategories] = useState([]);
    const [selectedMacroCategory, setSelectedMacroCategory] = useState("");
    const [visibleGroupedVariables, setVisibleGroupedVariables] = useState([]);

    const [applicableProducts, setApplicableProducts] = useState([]);

    let productCode = product.title
        .split(" ")
        .filter((ele) => ele !== "")
        .join("_");
    productCode = `${productCode}__${product.coreDataId}`;

    // const customOrder = [...ConsumerFilterOrder.customOrder];

    const customOrder = GetConsumerFilterOrder(productCategoryData?.label?.toLowerCase());
    const customOrderSub = [...ConsumerFilterOrder.customOrderSub];
    const alphabeticOrderFilters = [...ConsumerFilterOrder.alphabeticOrderFilters];

    const isHairCare = process.env?.REACT_APP_HAIR_CARE?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const macroOrder = getMacroCategoryOrder(productCategoryData?.label?.toLowerCase());

    const handleMissingFiltersDialogOpen = () => {
        setMissingFiltersDialogOpen(!missingFiltersDialogOpen);
    };

    useEffect(() => {
        const pros = productsSecondaryData.map((datum) => {
            if (datum.studyTypeMethodTitle === studyTypeMethod) {
                let productCode = datum.title
                    .split(" ")
                    .filter((ele) => ele !== "")
                    .join("_");
                productCode = `${productCode}__${datum.coreDataId}`;
                return productCode;
            }
        });
        setApplicableProducts(pros);
    }, [productsSecondaryData, studyTypeMethod]);

    useEffect(() => {
        if (type === "correlation") {
            const __consumerFilter = consumerFilter.map((datum) => {
                const productConsumerFilter = datum.consumer_filters;

                const backVarLabel = productConsumerFilter.backend_variable_display_label.filter((ele) => correlationConsumerFilters.includes(ele.displayLabel));

                const backVarMap = {};
                backVarLabel.forEach((ele) => {
                    const obj = productConsumerFilter.backend_variable_mapping[ele.backendVariable];
                    backVarMap[ele.backendVariable] = obj;
                });

                const groupedVar = {};
                backVarLabel.forEach((ele) => {
                    const array = productConsumerFilter.grouped_variables[ele.displayLabel];
                    groupedVar[ele.displayLabel] = array;
                });

                const objects = {
                    product_code: datum.product_code,
                    core_data_id: datum.core_data_id,
                    consumer_filters: {
                        backend_variable_display_label: backVarLabel,
                        backend_variable_mapping: backVarMap,
                        grouped_variables: groupedVar,
                    },
                };
                return objects;
            });

            setConsumerFilter([...__consumerFilter]);
        }
    }, [type, correlationConsumerFilters]);

    // Sync consumerFilter local state when Redux API data arrives
    useEffect(() => {
        if (type !== "correlation" && consumerFilterStoreData?.length > 0) {
            setConsumerFilter(consumerFilterStoreData);
        }
    }, [consumerFilterStoreData, type]);

    useEffect(() => {
        const tempData = consumerFilter.find((ele) => ele.product_code === product.title && ele.core_data_id.toString() === product.coreDataId.toString());
        const groupedData = tempData?.consumer_filters.grouped_variables;
        const __displayLabel = tempData?.consumer_filters.backend_variable_display_label ? tempData?.consumer_filters.backend_variable_display_label : [];
        const __sortedData = __displayLabel?.slice()
            ? __displayLabel.slice().sort((a, b) => {
                  const indexA = customOrder.indexOf(a.displayLabel);
                  const indexB = customOrder.indexOf(b.displayLabel);
                  if (indexA === -1 && indexB === -1) {
                      return a.displayLabel.localeCompare(b.displayLabel);
                  }
                  if (indexA === -1) {
                      return 1;
                  }
                  if (indexB === -1) {
                      return -1;
                  }
                  return indexA - indexB;
              })
            : [];

        setBackendVariableLabel(__sortedData);
        if (tempData?.consumer_filters.grouped_variables) {
            const groupedDisplayLabel = Object.keys(tempData?.consumer_filters.grouped_variables);
            let groupedDisplayLabelSortedDataArray;
            groupedDisplayLabelSortedDataArray = groupedDisplayLabel.slice().sort((a, b) => {
                const indexA = customOrder.indexOf(a);
                const indexB = customOrder.indexOf(b);
                if (indexA === -1 && indexB === -1) {
                    return a.localeCompare(b);
                }
                if (indexA === -1) {
                    return 1;
                }
                if (indexB === -1) {
                    return -1;
                }
                return indexA - indexB;
            });

            setGroupedVariables(groupedDisplayLabelSortedDataArray);
            if (isHairCare) {
                const macroCategoriesFromApi = tempData?.consumer_filters?.macro_category_display_label_map ?? {};
                const macroCategoryKeys = Object.keys(macroCategoriesFromApi);
                if (macroCategoryKeys.length > 0) {
                    const sortedMacroKeys = macroCategoryKeys.slice().sort((a, b) => {
                        const indexA = macroOrder.indexOf(a);
                        const indexB = macroOrder.indexOf(b);
                        if (indexA === -1 && indexB === -1) return a.localeCompare(b);
                        if (indexA === -1) return 1;
                        if (indexB === -1) return -1;
                        return indexA - indexB;
                    });
                    setMacroCategories(sortedMacroKeys);
                    setSelectedMacroCategory(sortedMacroKeys[0]);
                    const firstMacroGroups = macroCategoriesFromApi[sortedMacroKeys[0]] || [];
                    const visibleFiltered = groupedDisplayLabelSortedDataArray.filter((g) => firstMacroGroups.includes(g));
                    setVisibleGroupedVariables(visibleFiltered);
                    if (visibleFiltered.length > 0) {
                        setsSelectedFilter(visibleFiltered[0]);
                        setsSelectedFilterBackendVariables(groupedData[visibleFiltered[0]]);
                    }
                } else {
                    // Hair Care but macro_category_display_label_map absent — fallback to full list
                    setVisibleGroupedVariables(groupedDisplayLabelSortedDataArray);
                    setsSelectedFilter(groupedDisplayLabelSortedDataArray[0]);
                    setsSelectedFilterBackendVariables(groupedData[groupedDisplayLabelSortedDataArray[0]]);
                }
            } else {
                setsSelectedFilter(groupedDisplayLabelSortedDataArray[0]);
                setsSelectedFilterBackendVariables(groupedData[groupedDisplayLabelSortedDataArray[0]]);
            }
        }
    }, [consumerFilter, product]);

    useEffect(() => {
        const buildFilterBvArray = (tempData, _backendVariable) => {
            const array = tempData.consumer_filters?.backend_variable_mapping[_backendVariable].map((datum) => {
                return {
                    value: datum,
                    label: datum,
                    checked: false,
                };
            });
            return array;
        };

        if (Object.keys(currentFilterStoreData).length === 0) {
            const initialFiltersValue = {};
            productsSecondaryData.forEach((datum) => {
                let product = datum.title
                    .split(" ")
                    .filter((ele) => ele !== "")
                    .join("_");
                product = `${product}__${datum.coreDataId}`;
                const temp = {};
                let tempData = consumerFilter.find((ele) => ele.product_code == datum.title && ele.core_data_id == datum.coreDataId);
                tempData?.consumer_filters.backend_variable_display_label.forEach((element) => {
                    const _backendVariable = element.backendVariable;
                    if (currentFilterStoreData && currentFilterStoreData[product] && currentFilterStoreData[product].filters[_backendVariable]) {
                        temp[_backendVariable] = currentFilterStoreData[product].filters[_backendVariable];
                    } else {
                        const array = buildFilterBvArray(tempData, _backendVariable);
                        temp[_backendVariable] = [...array];
                    }
                });
                initialFiltersValue[product] = {
                    filters: { ...temp },
                    productCoreDataId: datum.coreDataId,
                };
                setCurrentFilterStoreData({ ...initialFiltersValue });
            });
            dispatch(
                updateConsumerFilterValue({
                    studyTypeMethodTitle: studyTypeMethod,
                    key: "currentSelectedFilters",
                    value: structuredClone(initialFiltersValue),
                })
            );
        }

        if (Object.keys(currentFilterAllStoreData).length === 0) {
            const initialSelectAllChecked = {};
            productsSecondaryData.forEach((datum) => {
                let product = datum.title
                    .split(" ")
                    .filter((ele) => ele !== "")
                    .join("_");
                product = `${product}__${datum.coreDataId}`;
                const temp = {};
                let tempData = consumerFilter.find((ele) => ele.product_code == datum.title && ele.core_data_id == datum.coreDataId) || {};
                Object.keys(tempData?.consumer_filters?.grouped_variables || {}).forEach((element) => {
                    const displayLabel = element;
                    temp[displayLabel] = currentFilterAllStoreData && currentFilterAllStoreData[product] && currentFilterAllStoreData[product].filters[displayLabel] ? currentFilterAllStoreData[product].filters[displayLabel] : false;
                });
                initialSelectAllChecked[product] = {
                    filters: { ...temp },
                    productCoreDataId: datum.coreDataId,
                };
                setCurrentFilterAllStoreData({ ...initialSelectAllChecked });
            });
            dispatch(
                updateConsumerFilterValue({
                    studyTypeMethodTitle: studyTypeMethod,
                    key: "currentSelectedAllFilters",
                    value: structuredClone(initialSelectAllChecked),
                })
            );
        }
    }, [consumerFilter]);

    useEffect(() => {
        if (filterData?.currentSelectedAllFilters) {
            setCurrentFilterAllStoreData(
                structuredClone(filterData.currentSelectedAllFilters)
            );
        }
    }, [filterData?.currentSelectedAllFilters]);

    useEffect(() => {
        if (filterData?.currentSelectedFilters) {
            setCurrentFilterStoreData(
                structuredClone(filterData.currentSelectedFilters)
            );
        }
    }, [filterData?.currentSelectedFilters]);

    const handleClick = () => {
        if (!disableFilter) {
            setOpen((prev) => !prev);
            setCurrentFilterStoreData((prev) => ({ ...prev, ...structuredClone(cfStoreData) }));
            setCurrentFilterAllStoreData(structuredClone(cfAllStoreData));
        }
    };

    const handleClickAway = () => {
        // setOpen(false);
    };

    const openButtons = () => {
        return (
            <div
                style={{
                    fontSize: "0.75rem",
                    color: "#4d4d4d",
                    borderBottom: "2px solid #dee2e6",
                    margin: "0px 40px",
                }}
            >
                <span
                    onClick={handleClick}
                    style={{
                        cursor: disableFilter ? "not-allowed" : "pointer",
                    }}
                >
                    {
                        <ManageAccountsIcon
                            fontSize="small"
                            className={disableFilter ? "" : "color-blue"}
                            sx={{
                                margin: "0px 5px 0px 0px",
                                color: disableFilter ? "action.disabled" : "primary.main",
                            }}
                        />
                    }
                    <span
                        style={{
                            fontWeight: 600,
                            color: disableFilter ? "#BDBDBD" : "",
                        }}
                    >
                        Filters
                    </span>
                    {
                        <ArrowDropDownIcon
                            className={disableFilter ? "" : "color-blue"}
                            // key="arrow-drop-down-icon"
                            sx={{
                                margin: "0px 0px 0px 5px",
                                color: disableFilter ? "action.disabled" : "primary.main",
                            }}
                        />
                    }
                    {missingFiltersStoreData && missingFiltersStoreData?.[productCode] && missingFiltersStoreData?.[productCode]?.isMissing === "true" && !disableFilter && (
                        <MatchNetMissingFiltersTooltip
                            missingFilters={missingFiltersStoreData}
                            product={productCode}
                        />
                    )}
                    {consumerFilterStoreData && !disableFilter && (
                        <AppliedFiltersTooltip
                            backendVariableLabel={backendVariableLabel}
                            cfStoreData={cfStoreData}
                            product={productCode}
                        />
                    )}
                </span>
            </div>
        );
    };

    const returnCheckBoxes = (label, i, backendVariable, productCode, displayLabel) => {
        let result = currentFilterStoreData[productCode]?.filters[backendVariable]?.filter((o) => o.value === label);
        return (
            <FormControlLabel
                key={i}
                sx={{
                    "& .MuiTypography-root": {
                        fontSize: 12,
                    },
                }}
                style={{
                    margin: "0px 0px 0px 0px",
                    padding: "3px 0px",
                    textAlign: "left",
                }}
                control={
                    <Checkbox
                        sx={{
                            "& .MuiSvgIcon-root": {
                                fontSize: 18,
                            },
                        }}
                        color="secondary"
                        id={`${backendVariable}-${i}`}
                        checked={result && result.length > 0 ? result[0].checked : false}
                        onChange={() => handleOnChange(backendVariable, label, "individualCheck", productCode, displayLabel)}
                        value={label}
                    />
                }
                label={label.replace(/ \|/g, ",").trim()}
            />
        );
    };

    const returnSelectAllAndClear = (label, displayLabel, productCode) => {
        return (
            <div
                className="px-2"
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    position: "sticky",
                    borderBottom: "1px solid grey",
                    backgroundColor: "white",
                }}
            >
                <div>
                    <FormControl
                        component="fieldset"
                        variant="standard"
                    >
                        <FormGroup>
                            <FormControlLabel
                                sx={{
                                    "& .MuiTypography-root": {
                                        fontSize: 14,
                                    },
                                }}
                                control={
                                    <Checkbox
                                        sx={{
                                            "& .MuiSvgIcon-root": {
                                                fontSize: 18,
                                            },
                                        }}
                                        color="secondary"
                                        checked={currentFilterAllStoreData[productCode]?.filters[displayLabel]}
                                        onChange={() => handleAllChecked(displayLabel, "allChecked", productCode)}
                                    />
                                }
                                label={label}
                            />
                        </FormGroup>
                    </FormControl>
                </div>
                <div>
                    <Button
                        size="small"
                        className="custom-btn-outlined color-blue"
                        variant="outlined"
                        style={{
                            padding: "0px 7px",
                            textTransform: "unset",
                            top: 4,
                        }}
                        onClick={() => handleAllChecked(displayLabel, "clearAll", productCode)}
                        // startIcon={<ScienceIcon />}
                    >
                        Clear All
                    </Button>
                </div>
            </div>
        );
    };

    const sortSubFilters = (displayLabel, backendVariable) => {
        const tempData = consumerFilter.find((ele) => ele.product_code == product.title && ele.core_data_id == product.coreDataId);
        const selectedFilterMappingObject = JSON.parse(JSON.stringify(tempData.consumer_filters.backend_variable_mapping?.[backendVariable]));

        // Sort selectedFilterMappingObject with extra elements placed at the start when displayLabel is not in  alphabeticOrderFilters list else alphabetical sort(default sorted from backend)
        if (!alphabeticOrderFilters.includes(displayLabel)) {
            selectedFilterMappingObject.sort((a, b) => {
                const indexA = customOrderSub.indexOf(a);
                const indexB = customOrderSub.indexOf(b);

                // If an element is not found in customOrderSub, move it to the start (by returning -1)
                if (indexA === -1 && indexB === -1) return 0; // both are extra, maintain their order
                if (indexA === -1) return -1; // a is extra, move it to the start
                if (indexB === -1) return 1; // b is extra, move it to the start

                // Otherwise, sort based on the order in array1
                return indexA - indexB;
            });
        }
        return selectedFilterMappingObject;
    };

    const checkSubFlag = (ele) => {
        let flag = false;
        ele[1].forEach((sub) => {
            if (sub.checked) {
                flag = true;
            }
        });
        return flag;
    };

    const checkFilterStatus = (coreDataId) => {
        let _filters = currentFilterStoreData;
        let sFlag = false;
        Object.entries(_filters).forEach((datum) => {
            if (datum[1].productCoreDataId === coreDataId && !sFlag) {
                Object.entries(datum[1].filters).forEach((ele) => {
                    sFlag = checkSubFlag(ele);
                });
            }
        });
        return sFlag;
    };

    const handleMacroCategoryClick = (macroCategory) => {
        const tempData = consumerFilter.find((ele) => ele.product_code === product.title && ele.core_data_id.toString() === product.coreDataId.toString());
        const groupedData = tempData?.consumer_filters.grouped_variables;
        const macroCatGroups = tempData?.consumer_filters?.macro_category_display_label_map?.[macroCategory] || [];
        const filtered = groupedVariables.filter((g) => macroCatGroups.includes(g));
        setSelectedMacroCategory(macroCategory);
        setVisibleGroupedVariables(filtered);
        if (filtered.length > 0) {
            setsSelectedFilter(filtered[0]);
            setsSelectedFilterBackendVariables(groupedData[filtered[0]]);
        }
    };

    const handleFilterLabelClick = (displayLabel) => {
        const tempData = consumerFilter.find((ele) => ele.product_code === product.title && ele.core_data_id.toString() === product.coreDataId.toString());
        const groupedData = tempData?.consumer_filters.grouped_variables;
        setsSelectedFilter(displayLabel);
        setsSelectedFilterBackendVariables(groupedData[displayLabel]);
    };

    const handleOnChange = (backendVariable, label, eventName, productCode, displayLabel) => {
        let datum = { ...currentFilterStoreData[productCode]?.filters };

        // * if the value of the passed position parameter matches with the current index, then we reverse its value. Then, if the value is true it will be converted to false using !item and if the value is false, then it will be converted to true.
        const updatedCheckedState = currentFilterStoreData?.[productCode]?.filters[backendVariable].map((item) => {
            return item.value === label ? { ...item, checked: !item.checked } : { ...item }; // Create new objects for each item
        });

        datum[backendVariable] = [...updatedCheckedState];
        let _filter = JSON.parse(JSON.stringify(currentFilterStoreData));
        _filter[productCode].filters = { ...datum };

        setCurrentFilterStoreData({ ..._filter });

        // logic to handle select all if every filters are checked one by one
        // looping over updatedCheckedState to check if every filter is selected or not to handle select all
        if (!updatedCheckedState.some((ele) => ele.checked === false)) {
            if (currentFilterAllStoreData[productCode]) {
                currentFilterAllStoreData[productCode].filters[displayLabel] = true;
            }
        } else {
            if (currentFilterAllStoreData[productCode]) {
                currentFilterAllStoreData[productCode].filters[displayLabel] = false;
            }
        }
    };

    const handleAllChecked = (displayLabel, eventName, productCode) => {
        let filterSelectionStatus = {};
        let coreDataId = currentFilterStoreData[productCode].productCoreDataId;
        let obj = { ...currentFilterAllStoreData[productCode].filters };

        if (eventName === "allChecked") {
            obj[displayLabel] = !obj[displayLabel];

            //handle every filters checkbox
            let datum = { ...currentFilterStoreData[productCode].filters };
            let _filter = { ...currentFilterStoreData };
            selectedFilterBackendVariables.forEach((backendVariable) => {
                const temp = currentFilterStoreData[productCode].filters[backendVariable].map((datum) => {
                    return {
                        value: datum.value,
                        label: datum.label,
                        checked: obj[displayLabel],
                    };
                });
                datum[backendVariable] = [...temp];
                _filter[productCode].filters = { ...datum };
            });

            setCurrentFilterStoreData({ ..._filter });

            // updating studyPageFilters global data

            let _allFilter = { ...currentFilterAllStoreData };
            _allFilter[productCode].filters = { ...obj };
            setCurrentFilterAllStoreData(_allFilter);
        } else if (eventName === "clearAll") {
            obj[displayLabel] = false;

            // clear every filters checkbox
            let datum = currentFilterStoreData[productCode].filters;
            let _allFilter = { ...currentFilterAllStoreData };
            let _filter = { ...currentFilterStoreData };
            selectedFilterBackendVariables.forEach((backendVariable) => {
                const temp = currentFilterStoreData[productCode].filters[backendVariable].map((datum) => {
                    return {
                        value: datum.value,
                        label: datum.label,
                        checked: false,
                    };
                });
                datum[backendVariable] = [...temp];
                _filter[productCode].filters = datum;
                _allFilter[productCode].filters = { ...obj };
            });

            setCurrentFilterStoreData({ ..._filter });
            setCurrentFilterAllStoreData({ ..._allFilter });

            // updating studyPageFilters global data
            filterSelectionStatus.filterSelected = checkFilterStatus(coreDataId);
            filterSelectionStatus.coreDataId = coreDataId;
        }
    };

    const getNewArray = (appliedFilters, unAppliedFilters) => {
        const appliedValues = new Set(appliedFilters.map((f) => f.value));

        return unAppliedFilters.map((obj) => ({
            ...obj,
            checked: appliedValues.has(obj.value),
        }));
    };

    const setAllData = (eachFilter, displayLabel, updatedFilters, item) => {
        const flag = !updatedFilters[eachFilter].some((ele) => ele.checked === false);
        if (currentFilterAllStoreData[item]) {
            currentFilterAllStoreData[item].filters[displayLabel] = flag;
        }
    };

    const applyFiltersToAllProducts = () => {
        const selectedProductFilters = currentFilterStoreData[productCode].filters;
        const checkedFilters = {};

        Object.keys(selectedProductFilters).forEach((filterCategory) => {
            const filterOptions = selectedProductFilters[filterCategory];
            const checkedOptions = filterOptions.filter((option) => option.checked === true);

            if (checkedOptions.length > 0) {
                checkedFilters[filterCategory] = checkedOptions;
            }
        });

        const checkedData = { ...currentFilterStoreData };
        Object.keys(currentFilterStoreData).map((item) => {
            const studyTypeMethodTitle = productsSecondaryData.find((datum) => {
                const productCode = datum.title
                    .split(" ")
                    .filter((ele) => ele !== "")
                    .join("_");

                return `${productCode}__${datum.coreDataId}` === item;
            })?.studyTypeMethodTitle;
            const updatedFilters = { ...currentFilterStoreData[item].filters };
            for (const key of Object.keys(updatedFilters)) {
                if (Object.keys(checkedFilters).includes(key)) {
                    const appliedFilters = checkedFilters[key];
                    const unAppliedFilters = updatedFilters[key];
                    const newArr = getNewArray(appliedFilters, unAppliedFilters);
                    updatedFilters[key] = newArr;
                } else {
                    const unAppliedFilters = updatedFilters[key];
                    const newArr = unAppliedFilters.map((obj2) => {
                        return { ...obj2, checked: false };
                    });
                    updatedFilters[key] = newArr;
                }
            }
            const finalFilters = {
                ...currentFilterStoreData[item],
                filters: studyTypeMethod === studyTypeMethodTitle ? updatedFilters : currentFilterStoreData[item].filters,
            };
            checkedData[item] = finalFilters;

            Object.keys(updatedFilters).map((eachFilter) => {
                const displayLabel = dataMappingStoreData[eachFilter];
                setAllData(eachFilter, displayLabel, updatedFilters, item);
            });
        });

        setCurrentFilterStoreData(checkedData);
        setCurrentFilterAllStoreData(currentFilterAllStoreData);
        dispatch(
            updateConsumerFilterValue({
                studyTypeMethodTitle: studyTypeMethod,
                key: "currentSelectedAllFilters",
                value: structuredClone(currentFilterAllStoreData),
            })
        );
        dispatch(
            updateConsumerFilterValue({
                studyTypeMethodTitle: studyTypeMethod,
                key: "currentSelectedFilters",
                value: structuredClone(checkedData),
            })
        );
        if (checkFilterSelection(checkedData)) {
            dispatch(loadWeightToggleState(false));
            dispatch(loadDisableWeightToggleState(true));
        } else {
            const arr = [];
            selectedStudies.forEach((item) => {
                arr.push(item?.["weighted"]);
            });
            const flag = arr.some((ele) => ele === true);

            if (flag) {
                dispatch(loadWeightToggleState(flag));
                dispatch(loadDisableWeightToggleState(!flag));
            }
        }

        const pcs = [];
        Object.keys(currentFilterStoreData).forEach(async (item) => {
            const studyTypeMethodTitle = productsSecondaryData.find((datum) => {
                const productCode = datum.title
                    .split(" ")
                    .filter((ele) => ele !== "")
                    .join("_");

                return `${productCode}__${datum.coreDataId}` === item;
            })?.studyTypeMethodTitle;
            const datum = {
                product: item.split("__")[0],
                coreDataId: currentFilterStoreData[item].productCoreDataId,
            };
            studyTypeMethod === studyTypeMethodTitle && pcs.push(datum);
        });
        handleFilterSubmit({
            product: null,
            coreDataId: null,
            type: "consumerFilterAll",
            consumerFilter: checkedData,
            pcs,
            selectedStudy: null,
            allAnalysisData,
            fetchOnlyCurrent: false,
            boxAnalysisSelection: {
                overall: overallBoxAnalysisSelection,
                secondary: secondaryBoxAnalysisSelection,
                agreement: agreementBoxAnalysisSelection,
                claims: claimsBoxAnalysisSelection,
                expressCltOverall: expressCltOverallBoxAnalysisSelection,
                fragranceOverall: fragranceOverallBoxAnalysisSelection,
                expressCltAdditional: expressCltAdditionalBoxAnalysisSelection,
                fragranceAdditional: fragranceAdditionalBoxAnalysisSelection,
            },
            studyTypeMethod: studyTypeMethod,
        });
        setOpen(false);
    };

    const handleSubmit = async () => {
        if (isFilterAcrossProductsStoreData) {
            const missingFilters = filterAcrossProducts(currentFilterStoreData, productCode, "cross study comparison", productsSecondaryData, studyTypeMethod);
            setTempMissingFilters(missingFilters);
            const result = applicableProducts.some((key) => missingFilters[key]?.isMissing === "true");
            if (result) {
                handleMissingFiltersDialogOpen();
            } else {
                dispatch(
                    updateConsumerFilterValue({
                        studyTypeMethodTitle: studyTypeMethod,
                        key: "missingFilters",
                        value: structuredClone(missingFilters),
                    })
                );
                applyFiltersToAllProducts();
            }
        } else {
            await dispatch(
                updateConsumerFilterValue({
                    studyTypeMethodTitle: studyTypeMethod,
                    key: "currentSelectedFilters",
                    value: structuredClone(currentFilterStoreData),
                })
            );
            await dispatch(
                updateConsumerFilterValue({
                    studyTypeMethodTitle: studyTypeMethod,
                    key: "currentSelectedAllFilters",
                    value: structuredClone(currentFilterAllStoreData),
                })
            );
            handleFilterSubmit({
                product: product.title
                    .split(" ")
                    .filter((ele) => ele !== "")
                    .join("_"),
                coreDataId: product.coreDataId,
                type: "consumerFilter",
                consumerFilter: currentFilterStoreData,
                pcs: [],
                selectedStudy: null,
                allAnalysisData,
                fetchOnlyCurrent: false,
                boxAnalysisSelection: {
                    overall: overallBoxAnalysisSelection,
                    secondary: secondaryBoxAnalysisSelection,
                    agreement: agreementBoxAnalysisSelection,
                    claims: claimsBoxAnalysisSelection,
                },
                studyTypeMethod: studyTypeMethod,
            });
            setOpen(false);
            if (checkFilterSelection(currentFilterStoreData)) {
                dispatch(loadWeightToggleState(false));
                dispatch(loadDisableWeightToggleState(true));
            } else {
                const arr = [];
                selectedStudies.forEach((item) => {
                    arr.push(item?.["weighted"]);
                });
                const flag = arr.some((ele) => ele === true);

                if (flag) {
                    dispatch(loadWeightToggleState(flag));
                    dispatch(loadDisableWeightToggleState(!flag));
                }
            }
        }
    };

    return (
        <>
            <ClickAwayListener
                mouseEvent="onMouseDown"
                touchEvent="onTouchStart"
                onClickAway={handleClickAway}
            >
                <Box sx={{ position: "relative" }}>
                    {openButtons()}
                    {open && (
                        <Box
                            role="presentation"
                            sx={{
                                position: "absolute",
                                top: 28,
                                right: 0,
                                left: 0,
                                border: "1px solid #dee2e6",
                                bgcolor: "background.paper",
                                width: isHairCare ? "600px" : "400px",
                                zIndex: 1,
                            }}
                        >
                            <div
                                className="filter-box "
                                style={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                }}
                            >
                                {isHairCare && macroCategories.length > 0 && (
                                    <div
                                        className="py-3"
                                        style={{
                                            width: "33%",
                                            minHeight: "475px",
                                            height: "475px",
                                            backgroundColor: "#9c27b0",
                                            textAlign: "left",
                                            overflowY: "scroll",
                                        }}
                                    >
                                        {macroCategories.map((macro, i) => (
                                            <div
                                                key={i}
                                                style={{
                                                    margin: "2px 0",
                                                    cursor: "pointer",
                                                    padding: "10px 20px",
                                                    width: "100%",
                                                }}
                                                className={selectedMacroCategory === macro ? "remove-opacity" : "enable-filter"}
                                                onClick={() => handleMacroCategoryClick(macro)}
                                            >
                                                <span style={{ fontSize: "0.75rem", color: "#fff", fontWeight: 600 }}>{macro}</span>
                                            </div>
                                        ))}
                                    </div>
                                )}
                                <div
                                    className="py-3"
                                    style={{
                                        width: isHairCare ? "33%" : "50%",
                                        minHeight: "475px",
                                        height: "475px",
                                        background: isHairCare ? "linear-gradient(0deg, rgba(126,168,233,1) 0%, rgba(255,255,255,1) 100%)" : "#9c27b0",
                                        textAlign: "left",
                                        overflowY: "scroll",
                                        borderRight: isHairCare ? "1px solid #dee2e6" : "none",
                                    }}
                                >
                                    {(isHairCare ? visibleGroupedVariables : groupedVariables)?.map((ele, i) => {
                                        return (
                                            <div
                                                key={i}
                                                style={{
                                                    margin: "2px 0",
                                                    cursor: "pointer",
                                                    padding: "10px 20px",
                                                    width: "100%",
                                                }}
                                                className={selectedFilter === ele ? "remove-opacity" : "enable-filter"}
                                                onClick={() => handleFilterLabelClick(ele)}
                                            >
                                                <span
                                                    style={{
                                                        fontSize: "0.75rem",
                                                        color: isHairCare ? "#4d4d4d" : "#fff",
                                                        fontWeight: 600,
                                                    }}
                                                >
                                                    {ele}
                                                </span>
                                            </div>
                                        );
                                    })}
                                </div>
                                <div
                                    className="filter-value-box pt-2 pb-0 px-0"
                                    style={{
                                        width: isHairCare ? "34%" : "50%",
                                        minHeight: "475px",
                                        height: "475px",
                                        background: isHairCare ? "#f8f9fa" : "linear-gradient(0deg, rgba(126,168,233,1) 0%, rgba(255,255,255,1) 100%)",
                                    }}
                                >
                                    <>
                                        {returnSelectAllAndClear("Select All", selectedFilter, productCode)}
                                        {selectedFilterBackendVariables && (
                                            <div
                                                className="px-3"
                                                style={{
                                                    overflowY: "scroll",
                                                    height: "386px",
                                                }}
                                            >
                                                <FormGroup>
                                                    {selectedFilterBackendVariables &&
                                                        selectedFilterBackendVariables.map((ele) => {
                                                            const sortedData = sortSubFilters(selectedFilter, ele);
                                                            return sortedData.map((label, i) => {
                                                                return returnCheckBoxes(label, i, ele, productCode, selectedFilter);
                                                            });
                                                        })}
                                                </FormGroup>
                                            </div>
                                        )}
                                    </>
                                    <div>
                                        <div
                                            className="px-2 py-1"
                                            style={{
                                                position: "absolute",
                                                right: 60,
                                                bottom: 0,
                                                cursor: "pointer",
                                                width: 45,
                                                height: 35,
                                                // overflow: "hidden",
                                            }}
                                            onClick={handleSubmit}
                                        >
                                            <img
                                                style={{
                                                    width: 30,
                                                    height: 25,
                                                    color: "white",

                                                    filter: "brightness(0) invert(1)",
                                                }}
                                                src={forwardPng}
                                                alt={"forward"}
                                            />
                                        </div>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 1440 320"
                                        >
                                            <path
                                                fill="#9c27b0"
                                                fillOpacity="1"
                                                d="M0,288L60,288C120,288,240,288,360,250.7C480,213,600,139,720,101.3C840,64,960,64,1080,106.7C1200,149,1320,235,1380,277.3L1440,320L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"
                                            ></path>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                        </Box>
                    )}
                </Box>
            </ClickAwayListener>
            {missingFiltersDialogOpen && (
                <MissingFiltersDialog
                    productCode={productCode}
                    currentFilterStoreData={currentFilterStoreData}
                    setCurrentFilterStoreData={setCurrentFilterStoreData}
                    handleFilterSubmit={handleFilterSubmit}
                    missingFiltersDialogOpen={missingFiltersDialogOpen}
                    handleMissingFiltersDialogOpen={handleMissingFiltersDialogOpen}
                    setOpen={setOpen}
                    setCurrentFilterAllStoreData={setCurrentFilterAllStoreData}
                    missingFilters={tempMissingFilters}
                    allAnalysisData={allAnalysisData}
                    studyTypeMethod={studyTypeMethod}
                    currentFilterAllStoreDataMatchNet={currentFilterAllStoreData}
                    applicableProducts={applicableProducts}
                    moduleName={"cross study comparison"}
                    productsSecondaryData={productsSecondaryData}
                />
            )}
        </>
    );
}

// Typechecking props for the OverallKpi
ConsumerFilter.propTypes = {
    product: PropTypes.object,
    productsSecondaryData: PropTypes.array,
    handleFilterSubmit: PropTypes.func,
    type: PropTypes.string,
    studyTypeMethod: PropTypes.string,
    disableFilter: PropTypes.bool,
};

export default ConsumerFilter;
